import React from 'react';
import TopHeader from '../components/TopHeader';
import Success from '../components/sucess';

const handleReturn = () => {
  window.location.href = '/compte/rendez-vous';
}
const ReviewSuccessPage = () => {

  return (
    <div className="success-page" style={{ backgroundColor: '#F6F6F6', minHeight: '100vh' }}>
      <TopHeader btn={true} />
      <Success 
          title="Avis envoyé !" 
          message="Votre avis va être vérifié puis sera publié. En notant vos professionnels, 
          vous participez à la vérification de la qualité des services proposés. Merci !" 
          buttonText="Retourner à mon compte" 
          onReturn={handleReturn} 
        />
     
    </div>
  );
};

export default ReviewSuccessPage;